import config from 'constants/config'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import { LUXURY_ESCAPES } from 'constants/brands'

export const getIsLuxLoyaltyEnabled = (state: App.State): boolean => !!(config.LUX_LOYALTY_ENABLED && state.optimizely.optimizelyFeatureFlags[OptimizelyFeatureFlags.luxLoyaltyFeatureToggle])
export const getIsLuxLoyaltyLoadTestEnabled = (state: App.State): boolean => !!(config.BRAND === LUXURY_ESCAPES && state.optimizely.optimizelyFeatureFlags[OptimizelyFeatureFlags.luxLoyaltyLoadTest])
export const getHasLuxLoyaltyAccount = (state: App.State): boolean => !!(getIsLuxLoyaltyEnabled(state) && state.luxLoyalty.account.data)
